import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import App from './App';
import './css/custom.css';
import './css/fonts/Nunito-Bold.ttf';
import './css/fonts/Nunito-Italic.ttf';
import './css/fonts/Nunito-Regular.ttf';
import pt from './translations/pt.json';

const locale = navigator.language;
const language = pt;

export const languageString = 'pt';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <IntlProvider locale={locale} messages={language}>
    <App />
  </IntlProvider>
);
